'use client';
import { getConfig } from '@/utils/config/config';
import { AppName } from '@fanduel/braze-content-cards-inbox/types/AppName';
import './styles/default.scss';
import dynamic from 'next/dynamic';
import { useNotificationBtn } from './notification-btn.hook';
import type { PRODUCT_THEME } from '@/utils/constants';
import { useStore } from '@/store/store';
import { ddRumAction } from '@/utils/datadog';

const WebApp = dynamic(() => import('@fanduel/braze-content-cards-inbox/web/App').then((mod) => mod.default), {
    ssr: false
});

export type NotificationBtnProps = {
    productTheme: PRODUCT_THEME;
};

/**
 * TODO
 * After release the useRef fix reinstall @fanduel/braze-content-cards-inbox with stable version
 * Also when we will have precompiled version of @fanduel/braze-content-cards-inbox, uninstall "@types/styled-components"
 * Also they are warning regarding custom styled-components props, because of version upgrade
 * This changes was needed to pass build and test the integration only
 */
export const NotificationBtn = ({ productTheme }: NotificationBtnProps) => {
    const { validateCard, handleClickOfCard } = useNotificationBtn(productTheme);

    const { key } = getConfig()?.services?.braze || {};
    const userId = useStore((state) => state.userContext?.accountSettings?.accountID);

    // Prevent invalid Braze init
    if (!key || !userId) return null;

    ddRumAction({
        name: `BRAZE_SDK_INIT_USER_ID`,
        description: `BrazeSDK init with user ID: ${userId}`,
        use_case: 'GLOBAL'
    });

    // TODO add suspense fallback when we will have design for it, so we are not shifting the buttons...
    // also we can add error boundary for better handling if webapp will fail to load
    return (
        <WebApp
            key={userId}
            brazeApiKey={key}
            userId={userId}
            appName={AppName.FD_CASINO}
            validateCard={validateCard}
            handleClickOfCard={handleClickOfCard}
        />
    );
};
